export const BALANCE_SHEET_TYPE_ENUM = {
  DN: "Mẫu số B 01 – DN",
  DNKLT: " Mẫu số B 01/CDHĐ – DNKLT",
};
